import React, { useState } from 'react';
import SidebarSubmenu from './SidebarSubmenu';
import { MenuItem } from '../../types/navigation.types';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { NavLink, useLocation } from 'react-router-dom';

interface SidebarMenuItemProps {
  item: MenuItem;
  isActive: boolean;
  isCollapsed: boolean;
}

const SidebarMenuItem: React.FC<SidebarMenuItemProps> = ({
  item,
  isActive,
  isCollapsed,
}) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const isSubmenuActive = item.submenu?.some(
    (subItem) => subItem.path === location.pathname
  );

  const handleToggleSubmenu = () => {
    if (item.hasSubmenu) setIsOpen(!isOpen);
  };

  return (
    <div>
      <NavLink
        to={item.path || '#'}
        onClick={handleToggleSubmenu}
        className={`flex items-center px-4 py-3 cursor-pointer rounded transition-colors duration-200 ease-in-out
          ${
            (isCollapsed && isSubmenuActive) || isActive
              ? 'text-primary'
              : 'hover:text-text-selected text-pink-500'
          }`}
      >
        {item.icon && (
          <item.icon
            className={`flex-shrink-0 w-5 h-5 
              ${
                (isCollapsed && isSubmenuActive) || isActive
                  ? 'text-primary'
                  : 'text-text-primary'
              }
              `}
          />
        )}
        <span
          className={`ml-2 text-sm whitespace-nowrap hover:text-text-selected
            ${isCollapsed ? 'hidden' : ''} 
            ${isActive ? 'text-primary font-bold' : 'text-text-primary'}`}
        >
          {item.text}
        </span>
        {!isCollapsed && item.hasSubmenu && (
          <span className="ml-auto">
            {isOpen ? (
              <ChevronUp className="w-4 h-4 text-text-primary" />
            ) : (
              <ChevronDown className="w-4 h-4 text-text-primary" />
            )}
          </span>
        )}
      </NavLink>

      {isOpen && item.submenu && !isCollapsed && (
        <SidebarSubmenu submenu={item.submenu} />
      )}
    </div>
  );
};

export default SidebarMenuItem;
